import {
  CLEAR_DOCUMENT_PROPS_SUCCESS,
  DOWNLOAD_PROGRESS,
  FETCH_ASSET_CODE_SUCCESS, FETCH_ASSET_FILTERS_SUCCESS,
  FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS,
  FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS,
  FETCH_DOCUMENT_TYPE_REPORT_SUCCESS,
  FETCH_ERROR,
  FETCH_FILTER_SUCCESS, FETCH_GLOBAL_ASSET_SEARCH_END, FETCH_GLOBAL_ASSET_SEARCH_START,
  FETCH_GLOBAL_SEARCH_END,
  FETCH_GLOBAL_SEARCH_START,
  FETCH_MASTER_FILTER_SUCCESS,
  FETCH_MODULE_SUCCESS, FETCH_PAGE_FIELDS_FILTER_SUCCESS, FETCH_PAGE_SETTING_FILTER_SUCCESS,
  FETCH_RELATIONSHIP_SEARCH,
  FETCH_START,
  FETCH_SUB_DOCUMENT_FILTER_SUCCESS,
  FETCH_SUB_ELEMENT_FILTER_SUCCESS,
  FETCH_SUB_MASTER_FILTER_SUCCESS,
  FETCH_SUCCESS,
  FETCH_SUPER_MASTER_FILTER_SUCCESS,
  FETCH_SUPER_START, GET_APPLICATION_MODULE_SUCCESS,
  GET_ASSET_PARAMETER_SEARCH_SUCCESS,
  GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS, GET_BACKGROUND_JOB_SUCCESS, GET_GLOBAL_ASSET_SEARCH_SUCCESS,
  GET_GLOBAL_PARAMETER_SEARCH_SUCCESS,
  HIDE_MESSAGE, PAGE_SETTING_FORM_VISIBLE_TOGGLE,
  QR_ALREADY_USED_CHECKED,
  SAVE_RELATIONSHIP_SEARCH,
  SHOW_MESSAGE,
  FETCH_DATA_START,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR
} from '../../constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  dataLoading: false,
  message: '',
  filters: {},
  pageSettingFilters: {},
  subDocumentFilters: {},
  subElementFilters: {},
  pageFieldsFilters: {},
  modules: [],
  documentFilters: {},
  assetCodes: [],
  documentType: [],
  tableAssetData: [],
  tableDocumentTypeData: [],
  relationshipSearch: [],
  masterFilters: {},
  superMasterFilters: {},
  subMasterFilters: {},
  superLoading: false,
  download: 0,
  downloadProgressForExcel: 0,
  assetSpareIssueData: [],
  assetParameterSearchData: null,
  globalSearchData: null,
  assetSearchData: null,
  globalSearchLoading: false,
  assetSearchLoading: false,
  qrUsed: null,
  applicationModules: [],
  pageSettingVisible: false,
  assetFilters: null,
  backgroundJobStatus: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: '', message: '', loading: true };
    }
    case FETCH_GLOBAL_SEARCH_START: {
      return { ...state, error: '', message: '', globalSearchLoading: true };
    }
    case FETCH_GLOBAL_SEARCH_END: {
      return { ...state, error: '', message: '', globalSearchLoading: false };
    }
    case FETCH_GLOBAL_ASSET_SEARCH_START: {
      return { ...state, error: '', message: '', assetSearchLoading: true };
    }
    case FETCH_GLOBAL_ASSET_SEARCH_END: {
      return { ...state, error: '', message: '', assetSearchLoading: false };
    }
    case FETCH_SUPER_START: {
      return { ...state, error: '', message: '', superLoading: true };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: '', message: '', loading: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, error: '', message: action.payload, loading: false };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, error: action.payload, message: '' };
    }
    case HIDE_MESSAGE: {
      return { ...state, loading: false, error: '', message: '' };
    }
    case FETCH_FILTER_SUCCESS: {
      return { ...state, filters: action.data };
    }
    case FETCH_PAGE_SETTING_FILTER_SUCCESS: {
      return { ...state, pageSettingFilters: action.data };
    }
    case FETCH_SUB_DOCUMENT_FILTER_SUCCESS: {
      return { ...state, subDocumentFilters: action.data };
    }
    case FETCH_SUB_ELEMENT_FILTER_SUCCESS: {
      return { ...state, subElementFilters: action.data };
    }
    case FETCH_PAGE_FIELDS_FILTER_SUCCESS: {
      return { ...state, pageFieldsFilters: action.data };
    }
    case FETCH_MASTER_FILTER_SUCCESS: {
      return { ...state, masterFilters: action.data };
    }
    case FETCH_SUB_MASTER_FILTER_SUCCESS: {
      return { ...state, subMasterFilters: action.data };
    }
    case FETCH_SUPER_MASTER_FILTER_SUCCESS: {
      return { ...state, superMasterFilters: action.data, superLoading: false };
    }
    case FETCH_MODULE_SUCCESS: {
      return { ...state, modules: action.data };
    }
    case FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS: {
      return { ...state, documentFilters: action.data };
    }
    case FETCH_ASSET_CODE_SUCCESS: {
      return { ...state, assetCodes: action.data };
    }
    case FETCH_DOCUMENT_TYPE_REPORT_SUCCESS: {
      return { ...state, documentType: action.data }
    }
    case FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        tableAssetData: action.data.assets,
        tableDocumentTypeData: action.data.documentTypes,
      }
    }
    case FETCH_RELATIONSHIP_SEARCH: {
      return { ...state, relationshipSearch: [] };
    }
    case CLEAR_DOCUMENT_PROPS_SUCCESS: {
      return {
        ...state,
        documentFilters: {},
        tableAssetData: [],
        assetCodes: [],
        documentType: [],
        tableDocumentTypeData: []
      }
    }
    case SAVE_RELATIONSHIP_SEARCH: {
      return { ...state, relationshipSearch: action.data };
    }
    case DOWNLOAD_PROGRESS: {
      return { ...state, download: action.download };
    }
    case GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS: {
      return { ...state, assetSpareIssueData: action.data };
    }
    case GET_ASSET_PARAMETER_SEARCH_SUCCESS: {
      return {
        ...state,
        assetParameterSearchData: action.data
      }
    }
    case GET_GLOBAL_PARAMETER_SEARCH_SUCCESS: {
      return {
        ...state,
        globalSearchData: action.data,
        globalSearchLoading: false
      }
    }
    case GET_GLOBAL_ASSET_SEARCH_SUCCESS: {
      return {
        ...state,
        assetSearchData: action.data,
        assetSearchLoading: false
      }
    }
    case QR_ALREADY_USED_CHECKED: {
      return {
        ...state,
        qrUsed: { id: action.id, status: action.status, time: new Date().getTime() }
      }
    }
    case GET_APPLICATION_MODULE_SUCCESS: {
      return { ...state, applicationModules: action.data };
    }
    case PAGE_SETTING_FORM_VISIBLE_TOGGLE: {
      // console.log(state)
      return { ...state, pageSettingVisible: !state.pageSettingVisible }
    }
    case FETCH_ASSET_FILTERS_SUCCESS: {
      // console.log(state)
      return { ...state, assetFilters: action.data }
    }
    case GET_BACKGROUND_JOB_SUCCESS: {
      return { ...state, backgroundJobStatus: action.data }
    }
    case FETCH_DATA_START: {
      return { ...state, dataLoading: true }
    }
    case FETCH_DATA_SUCCESS: {
      return { ...state, dataLoading: false }
    }
    case FETCH_DATA_ERROR: {
      return { ...state, dataLoading: false, error: action.payload }
    }
    default:
      return state;
  }
}
